import React, {useEffect, useRef, useState} from "react";
import {formatClock} from "./utils/chessFunctions";
import {playSound} from "./utils/sounds";

const LOW_TIME = 20000;
const WARNING_TIME = 10000;

/**
 * Counts down locally between server updates.
 *  - timeLeft: ms left for this player when the server last told us (syncedAt)
 *  - syncedAt: Date.now() when timeLeft was received
 *  - running: whether this clock is currently ticking
 *  - warn: play a gentle tick when this clock drops under 10 seconds (only for your own clock)
 */
const ChessClock = ({timeLeft, syncedAt, running, warn = false}) => {
    const [now, setNow] = useState(Date.now());
    const warned = useRef(false);

    useEffect(() => {
        if (!running) return;
        setNow(Date.now());
        const interval = setInterval(() => setNow(Date.now()), 100);
        return () => clearInterval(interval);
    }, [running, syncedAt]);

    const remaining = timeLeft === undefined || timeLeft === null
        ? null
        : running ? timeLeft - Math.max(0, now - (syncedAt || now)) : timeLeft;

    useEffect(() => {
        if (!warn || remaining === null) return;
        if (running && remaining < WARNING_TIME && remaining > 0 && !warned.current) {
            warned.current = true;
            playSound("lowtime");
        }
        if (remaining >= WARNING_TIME) warned.current = false;
    }, [warn, remaining, running]);

    const low = remaining !== null && remaining < LOW_TIME;

    return (
        <div className={`clock ${running ? "active" : ""} ${low ? "low" : ""}`} role="timer" aria-live="off">
            {formatClock(remaining)}
        </div>
    );
};

export default ChessClock;
